// Copyright (c) 2024 Deere & Company

import FactoryDuplicatePinPlate from './components/factory-duplicate-pin-plate';
import actionCreators from './action-creators';
import {connect} from 'react-redux';
import {getDateFormat} from '../../shared/services/get-date-format';

const getStateToBindToContainerProps = state => ({
    ...state.factoryDuplicatePinPlate,
    dateFormat: getDateFormat(state.user.details.settings.general.dateFormat.key),
    dealerRecommendationCount: state.dealerRecommendationsReducer.dealerRecommendations.totalElements,
    facets: {
        ...state.factoryDuplicatePinPlate.facets,
        dealerAccountsFacet: {
            ...state.factoryDuplicatePinPlate.facets.dealerAccountsFacet,
            allowedDealers: state.user.details.settings.dealer.accounts.selectedAccounts
        }
    },
    factoryDuplicatePinPlateCount: state.factoryDuplicatePinPlate.factoryDuplicatePinPlates.length,
    machineStatusUpdateCount: state.machineStatusUpdate.machineStatusUpdates.length,
    registrationReviewCount: state.registrationReview.registrations.length,
    searchResultsCount: state.productSearch.searchResults.length,
    security: state.user.security,
    transferApprovalsCount: state.transferApprovals.transfers.length,
    user: state.user.details
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(FactoryDuplicatePinPlate);



// WEBPACK FOOTER //
// ./src/product/factory-users-duplicate-pin-plate/state-connector.js